/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const WebkassaCashboxStatus = {
    CREATED: 'CREATED',
    ACTIVE: 'ACTIVE',
    OFD_BLOCKED: 'OFD_BLOCKED',
    DATA_FAILURE: 'DATA_FAILURE',
    TAX_INSPECTOR_BLOCKED: 'TAX_INSPECTOR_BLOCKED',
    INACTIVE: 'INACTIVE'
} as const;
export type WebkassaCashboxStatus = typeof WebkassaCashboxStatus[keyof typeof WebkassaCashboxStatus];

